var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'mb-2 ' + (_vm.row.class ? _vm.row.class : '')},[_c('div',{class:'row ' + (_vm.flexStart || _vm.row.flexStart ? ' ' : 'flex-end ')},_vm._l((_vm.row.columns),function(input,index){return _c('div',{key:input.name + String(Math.random(1023)),class:'col-lg-' +
          (input.colwidth ? input.colwidth : 12 / _vm.row.colnum) +
          ' ' +
          (index > 0 ? 'pl-1' : '') +
          ' ' +
          (index < _vm.row.columns.length - 1 ? 'pr-1' : '')},[_c('FormGroup',{attrs:{"input":input,"value":input.value},on:{"handleChange":function (e) { return _vm.handleChange(e); }}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }